"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
exports.default = react_1.default.memo(ParticipantsTyping);
function ParticipantsTyping(props) {
    if (!props.usernames.length) {
        return null;
    }
    let text;
    if (props.usernames.length === 1) {
        text = `${props.usernames[0]} is typing...`;
    }
    else {
        text = props.usernames[0];
        for (let i = 1; i < props.usernames.length - 1; i++) {
            text += `, ${props.usernames[i]}`;
        }
        text += ` and ${props.usernames[props.usernames.length - 1]} are typing...`;
    }
    return (react_1.default.createElement(Typography_1.default, { variant: "body2" }, text));
}
